export const appRoutes: { [key: string]: string } = {
  home: '/home',
  changePassword: '/change-password',
  changeUserInfo: '/change-user-info',
  checkPasswordCode: '/check-password-code',
  errorPage: '/error-page',
  favorites: '/favorites',
  legal: '/legal',
  profile: '/profile',
  register: '/register',
  resetPassword: '/reset-password',
  savedSearches: '/saved-searches',
  search: '/search',
  login: '/login',
  test: '/test',
  verifyEmail: '/verify-email',
  verifyEmailCode: '/verify-email-code',
  sell: '/sell',
  createListing: '/create-listing',
  listingInfo: '/listing-info',
  itemDetail: '/item-detail',
};
